import React from "react";
import Col from "react-bootstrap/Col";

const EducationCard = ({ value }) => {
  const {
    degree,
    university,
    time,
    description
  } = value;
  return (
      <Col md="12">
      < div className="p-2">
          <span className="h3">{university}</span>  ( <span className="primary-text">{ time }</span> )
          <div className="h6">{degree}</div>
          <p className="primary-text">{description}</p>
         <hr />
         
       </div>
      </Col>
  );
};


export default EducationCard;